import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';

export default function ProficiencyBonus({ characterId, value, onChange }: {
    characterId: number; value: number; onChange: (value: number) => void;
}) {
    const { apiRequest } = useAuth();
    const [draft, setDraft] = useState(`+${value}`);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const save = async () => {
        const next = Number(draft);
        if ((draft.trim() !== '' && !/^\+?\d+$/.test(draft.trim())) || !Number.isInteger(next) || next < 0 || next > 2147483647) {
            setError('Enter a non-negative integer.');
            return;
        }
        if (next === value) { setDraft(`+${next}`); setError(''); return; }
        setSaving(true);
        setError('');
        try {
            await apiRequest(`/api/characters/${characterId}/proficiency-bonus`, 'PATCH', { value: next });
            onChange(next);
            setDraft(`+${next}`);
        } catch {
            setError('Could not save. Try again.');
        } finally {
            setSaving(false);
        }
    };
    return <div className="proficiency-bonus">
        <label>Proficiency <input aria-label="Proficiency bonus" type="text" inputMode="numeric" value={draft}
            disabled={saving} aria-invalid={!!error} onChange={event => setDraft(event.target.value)} onBlur={save}
            onKeyDown={event => { if (event.key === 'Enter') event.currentTarget.blur(); }} /></label>
        {saving && <small role="status">Saving…</small>}
        {error && <small role="alert">{error} <button type="button" onClick={save}>Retry</button></small>}
    </div>;
}
